/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModifiedPainBehavioralAliases {
  ADAPTATION_MECHANICAL_VENTILATION_TEXT = 'adaptation-mechanical-ventilation-text',
  CRIES_FIELD = 'cries-field',
  CRIES_FORM = 'cries-form',
  CRIES_RADIO_GROUP = 'cries-radio-group',
  CRIES_TEXT = 'cries-text',
  FACE_EXPRESSION_FIELD = 'face-expression-field',
  FACE_EXPRESSION_FORM = 'face-expression-form',
  FACE_EXPRESSION_RADIO_GROUP = 'face-expression-radio-group',
  FACIAL_EXPRESSION_TEXT = 'facial-expression-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  MODIFIED_PAIN_BEHAVIORAL_LAYOUT = 'modified-pain-behavioral-layout',
  MOVIMENTS_FIELD = 'moviments-field',
  MOVIMENTS_FORM = 'moviments-form',
  MOVIMENTS_RADIO_GROUP = 'moviments-radio-group',
  MPB_CONTEXTUAL_BAR = 'mpb-contextualBar',
  MPB_PANEL = 'mpb-panel',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_MODAL = 'reference-modal',
  REFERENCE_PANEL = 'reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
}
export { ModifiedPainBehavioralAliases };
